<template>
  <div>
    <div class="mb-3">
      <label
        for="juridictionNameInput"
        class="form-label required"
      >
        {{ $t('words.name') }}
      </label>
      <ValidationProvider
        v-slot="{ classes, errors }"
        ref="name"
        rules="required"
      >
        <div
          class="control"
          :class="classes"
        >
          <input
            id="juridictionNameInput"
            v-model="formData.displayName"
            type="text"
            class="form-control"
            :placeholder="$t('words.name')"
          >
          <span class="form-errors">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </div>
    <div class="mb-3">
      <label
        for="juridictionCodeInput"
        class="form-label required"
      >
        {{ $t('jurisdictions.form.identificationCode') }}
      </label>
      <ValidationProvider
        v-slot="{ classes, errors }"
        ref="name"
        rules="required"
      >
        <div
          class="control"
          :class="classes"
        >
          <input
            id="juridictionCodeInput"
            v-model="formData.codename"
            type="text"
            class="form-control"
            :placeholder="$t('jurisdictions.form.identificationCode')"
          >
          <span class="form-errors">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
    </div>
    <MunicipalitiesSelector
      :municipalities="formData.municipalities"
      v-on="$listeners"
      @set="setMunicipalities"
    />
  </div>
</template>

<script>
import i18n from '@/common/i18n/i18n.js';
import { mapState, mapMutations } from 'vuex';

import MunicipalitiesSelector from '@/app/jurisdiction/components/Municipalities/MunicipalitiesSelector.vue';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: i18n.messages[i18n.locale].words.requiredField
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'JuridictionForm',

  components: {
    MunicipalitiesSelector,
    ValidationProvider
  },

  data() {
    return {
      formData: {
        displayName: null,
        codename: null,
        municipalities: []
      }
    };
  },

  computed: {
    ...mapState('jurisdiction', [
      'currentJurisdiction',
      'jurisdictionForm'
    ])
  },

  watch: {
    currentJurisdiction: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.formData.displayName = newValue.display_name;
          this.formData.codename = newValue.codename;
          this.formData.municipalities = newValue.municipalities;
        }
      }
    },
    formData: {
      deep: true,
      handler(newValue) {
        this.SET_JURIDICTION_FORM(newValue);
      }
    }
  },

  methods: {
    ...mapMutations('jurisdiction', [
      'SET_JURIDICTION_FORM'
    ]),

    setMunicipalities(values) {
      this.formData.municipalities = values;
    }
  }
};
</script>

<style lang="less" scoped>
.form-label {
  margin-bottom: .25rem;
}
</style>